import { Skeleton } from 'antd';
import { useSelector } from 'react-redux';
import { getImageApi } from 'src/api/apiGetImage';
import { modifyURL } from 'src/const/contain';
import useQueryApi from 'src/hooks/useApiQuery';
import { contentfulSelector } from 'src/redux/selectors/contentfulSelector';
import { quoteDetailSelector } from 'src/redux/selectors/quoteDetailSelector';

const Banner: React.FC = () => {
    const { productQuote = {} } = useSelector(quoteDetailSelector);
    const { code } = productQuote;
    const {
        ukIrelandCampaignBanner,
        europeCampaignBanner,
        restOfWorldCampaignBanner,
        eventCampaignBanner,
    } = useSelector(contentfulSelector);

    const getImageId = (codeQuote: string) => {
        let imageField: any = europeCampaignBanner;
        switch (codeQuote) {
            case 'YGTUKI':
                imageField = ukIrelandCampaignBanner;
                break;
            case 'YGTTE':
                imageField = eventCampaignBanner;
                break;
            case 'YGTROW':
                imageField = restOfWorldCampaignBanner;
                break;
            default:
                imageField = europeCampaignBanner;
                break;
        }

        return imageField?.sys?.id || '';
    };

    const { data: imageField } = useQueryApi(
        ['image', getImageId(code)],
        () => getImageApi(getImageId(code)),
        {
            enabled: code && !!getImageId(code),
        },
    );

    const addHttpsImage = (url: string) => {
        if (url) {
            return `http:${url}`;
        }
        return '';
    };

    const bannerImage = addHttpsImage((imageField as any)?.fields?.file?.url);

    return (
        <>
            {!!getImageId(code) && (
                <div className="banner">
                    {bannerImage ? (
                        <img
                            alt="Banner"
                            src={modifyURL(bannerImage, 1600)}
                            className="img-banner"
                        />
                    ) : (
                        <Skeleton.Image
                            active={true}
                            className="skeleton-image"
                        />
                    )}
                </div>
            )}
        </>
    );
};

export default Banner;
